<!-- ==========================================================================
     RESUMEN DEL LOTE
     ========================================================================== -->

<div class="signature-page">

  <section class="signature-summary">

    <!-- HEADER -->
    <div class="summary-page-header">

      <div class="summary-page-heading">

        <div class="summary-page-icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>

        <div class="summary-page-title">
          <span class="section-eyebrow">
            SEGUIMIENTO DE FIRMA
          </span>

          <h3>
            {{ lote?.titulo }}
          </h3>

          <p>
            Selecciona un grupo o firmante para consultar su detalle.
          </p>
        </div>

      </div>


      <!-- Mantiene el collapse actual -->
      <button class="btn-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample"
        aria-expanded="true" aria-controls="collapseExample">

        <i class="fa-solid fa-chevron-up toggle-icon"></i>

      </button>

    </div>


    <!-- ================================================================
         RESÚMENES
         ================================================================ -->

    <div class="collapse show" id="collapseExample">

      <div class="resume-list">

        <div class="resume-item" *ngFor="let resumen of resumenAvanceFirma; index as i"
          (click)="selectResumeItem(resumen)">


          <!-- HEADER -->
          <div class="resume-header">

            <div class="resume-group">

              <div class="resume-group-icon" [class.group]="resumen.es_grupo" [class.individual]="!resumen.es_grupo">

                <i class="fa-solid" [ngClass]="resumen.es_grupo ? 'fa-users' : 'fa-user'">
                </i>

              </div>


              <div class="resume-group-info">

                <span class="resume-type">
                  {{ resumen.es_grupo ? 'Grupo de firma' : 'Firma individual' }}
                </span>

                <strong class="resume-group-name">
                  {{ resumen.nombre }}
                </strong>

              </div>

            </div>


            <div class="resume-header-actions">

              <span class="resume-tag" *ngIf="resumen.es_grupo">
                Firma grupal
              </span>

              <span class="resume-tag individual" *ngIf="!resumen.es_grupo">
                Firma individual
              </span>


              <!-- Indica visualmente que se puede hacer click -->
              <span class="resume-open-icon">
                <i class="fa-solid fa-chevron-right"></i>
              </span>

            </div>

          </div>


          <!-- ============================================================
               ESTADÍSTICAS
               ============================================================ -->

          <div class="resume-stats">

            <!-- SOLICITADAS -->
            <div class="resume-stat">

              <div class="resume-stat-icon requested">
                <i class="fa-regular fa-file-lines"></i>
              </div>

              <div class="resume-stat-content">

                <span class="resume-stat-label">
                  Solicitadas
                </span>

                <strong class="resume-stat-value">
                  {{ resumen.cantidad_total }}
                </strong>

              </div>

            </div>


            <!-- COMPLETADAS -->
            <div class="resume-stat">

              <div class="resume-stat-icon completed">
                <i class="fa-solid fa-check"></i>
              </div>

              <div class="resume-stat-content">

                <span class="resume-stat-label">
                  Completadas
                </span>

                <strong class="resume-stat-value completed-value">
                  {{ resumen.cantidad_firmada }}
                </strong>

              </div>

            </div>


            <!-- PENDIENTES -->
            <div class="resume-stat">

              <div class="resume-stat-icon pending">
                <i class="fa-regular fa-clock"></i>
              </div>

              <div class="resume-stat-content">

                <span class="resume-stat-label">
                  Pendientes
                </span>

                <strong class="resume-stat-value pending-value">
                  {{
                  resumen.cantidad_total -
                  resumen.cantidad_firmada
                  }}
                </strong>

              </div>

            </div>

          </div>


          <!-- ============================================================
               PROGRESO
               ============================================================ -->

          <div class="resume-progress">

            <div class="resume-progress-header">

              <span>
                Progreso general
              </span>

              <strong>
                {{ resumen.cantidad_firmada }}
                /
                {{ resumen.cantidad_total }}
              </strong>

            </div>


            <div class="resume-progress-track">

              <div class="resume-progress-bar" [style.width.%]="getProgress(resumen)">
              </div>

            </div>


            <div class="resume-progress-bottom">

              <span>
                {{ getProgress(resumen) }}% completado
              </span>

              <span class="resume-view-detail">
                Ver firmantes
                <i class="fa-solid fa-arrow-right"></i>
              </span>

            </div>

          </div>

        </div>

      </div>

    </div>

  </section>


  <!-- ==========================================================================
       FIRMANTES
       ========================================================================== -->

  <section class="signers-section" *ngIf="resumeItemSelected && usuariosFirma.length > 0">


    <!-- HEADER -->
    <div class="signers-header">

      <div class="signers-heading">

        <div class="signers-icon">
          <i class="fa-solid fa-users"></i>
        </div>

        <div>

          <span class="section-eyebrow">
            DETALLE
          </span>

          <h3>
            Firmantes
          </h3>

          <p>
            Consulta el estado de firma de los usuarios.
          </p>

        </div>

      </div>


      <div class="signers-count">
        <strong>
          {{ usuariosFirma.length }}
        </strong>

        <span>
          firmantes
        </span>
      </div>

    </div>


    <!-- ================================================================
         BUSCADOR
         ================================================================ -->

    <div class="signers-search">

      <form [formGroup]="formSearch">

        <label class="search-label">
          Buscar firmante
        </label>


        <div class="search-wrapper">

          <span class="search-icon">
            <i class="fa-solid fa-magnifying-glass"></i>
          </span>

          <input type="text" class="search-input" placeholder="Buscar por nombre..." aria-label="Buscar por nombre"
            formControlName="usuario">


          <button type="button" class="search-button" (click)="getUsers()">

            <i class="fa-solid fa-magnifying-glass"></i>

            <span>
              Buscar
            </span>

          </button>

        </div>

      </form>

    </div>


    <!-- ================================================================
         TABLA DESKTOP
         ================================================================ -->

    <div class="signers-table-wrapper">

      <table class="signers-table">

        <caption class="visually-hidden">
          Firmantes
        </caption>


        <thead>

          <tr>

            <th scope="col">
              Nombre
            </th>

            <th scope="col">
              Usuario
            </th>

            <th scope="col">
              Scratchcard
            </th>

            <th scope="col">
              Correo
            </th>

            <th scope="col">
              Estado firma
            </th>

          </tr>

        </thead>


        <tbody>

          <tr *ngFor="let usuario of usuariosFirma; index as i">

            <!-- NOMBRE -->
            <td>

              <div class="signer-user">

                <span class="signer-avatar">
                  <i class="fa-solid fa-user"></i>
                </span>

                <strong>
                  {{ usuario?.firstName }}
                  {{ usuario?.lastName }}
                </strong>

              </div>

            </td>


            <!-- USERNAME -->
            <td>
              <span class="signer-secondary">
                {{ usuario?.username }}
              </span>
            </td>


            <!-- SCRATCHCARD -->
            <td>

              <span class="scratchcard-code">
                {{ usuario?.scratchcard }}
              </span>

            </td>


            <!-- CORREO -->
            <td>

              <span class="signer-email">
                {{ usuario?.email }}
              </span>

            </td>


            <!-- ESTADO -->
            <td>

              <span class="status-badge completed" *ngIf="usuario.firmado">

                <i class="fa-solid fa-check"></i>

                Firmado / Completado

              </span>


              <span class="status-badge pending" *ngIf="!usuario.firmado">

                <i class="fa-regular fa-clock"></i>

                Pendiente

              </span>

            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <!-- ================================================================
         FIRMANTES MÓVIL
         ================================================================ -->

    <div class="signers-mobile">

      <div class="signer-mobile-item" *ngFor="let usuario of usuariosFirma; index as i">


        <div class="signer-mobile-header">

          <div class="signer-user">

            <span class="signer-avatar">
              <i class="fa-solid fa-user"></i>
            </span>

            <div class="signer-mobile-name">

              <strong>
                {{ usuario?.firstName }}
                {{ usuario?.lastName }}
              </strong>

              <span>
                {{ usuario?.username }}
              </span>

            </div>

          </div>


          <span class="mobile-status completed" *ngIf="usuario.firmado">

            <i class="fa-solid fa-check"></i>

          </span>


          <span class="mobile-status pending" *ngIf="!usuario.firmado">

            <i class="fa-regular fa-clock"></i>

          </span>

        </div>


        <div class="signer-mobile-details">

          <div class="signer-mobile-detail">

            <span>
              Correo
            </span>

            <strong>
              {{ usuario?.email }}
            </strong>

          </div>


          <div class="signer-mobile-detail">

            <span>
              Scratchcard
            </span>

            <strong>
              {{ usuario?.scratchcard }}
            </strong>

          </div>

        </div>


        <div class="signer-mobile-footer">

          <span class="status-badge completed" *ngIf="usuario.firmado">

            <i class="fa-solid fa-check"></i>

            Firmado / Completado

          </span>


          <span class="status-badge pending" *ngIf="!usuario.firmado">

            <i class="fa-regular fa-clock"></i>

            Pendiente

          </span>

        </div>

      </div>

    </div>

  </section>

</div>